var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacherQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 855 c-50 -49 -15 -135 55 -135 41 0 80 39 80 80 0 41 -39 80 -80 80 -19 0 -40 -9 -55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 800 l0 -40 200 0 200 0 0 -180 0 -180 -40 0 -40 0 0 40 0 40 -80 0 -80 0 0 -40 0 -40 -60 0 -60 0 0 -40 0 -40 240 0 240 0 0 40 c0 33 -3 40 -20 40 -19 0 -20 7 -20 200 0 187 -1 201 -20 220 -19 19 -33 20 -240 20 l-220 0 0 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 655 l-25 -24 0 -276 0 -275 40 0 40 0 0 120 0 120 40 0 40 0 0 -120 0 -120 40 0 40 0 0 260 0 260 120 0 120 0 0 40 0 40 -215 0 c-216 0 -216 0 -240 -25z m135 -155 l0 -100 -40 0 -40 0 0 100 0 100 40 0 40 0 0 -100z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherQuestion);
export default __webpack_public_path__ + "static/media/teacherQuestion.ef727a6aa279fa43ad5c1227a5856c3d.svg";
export { ForwardRef as ReactComponent };